import { render } from "./orderTable.vue?vue&type=template&id=d0ffdc34"
import script from "./orderTable.vue?vue&type=script&lang=js"
export * from "./orderTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__